// BBatts: single source of truth for role names — must match the API's role
// vocabulary in FreightOps/Models/UserRoles.cs (nothing enforces that match).
export const ROLE_ADMIN = 'Admin';
export const ROLE_MANAGER = 'Manager';
export const ROLE_DOCK = 'Dock';

// Every assignable role, in escalation order. Drives the role pickers on the
// Users admin page.
export const ASSIGNABLE_ROLES = [
  { name: 'Dock', code: ROLE_DOCK },
  { name: 'Manager', code: ROLE_MANAGER },
  { name: 'Admin', code: ROLE_ADMIN },
];

// Roles allowed into OS&D processing (work queue, destroyed items, counts,
// destroy/final disposition). Dock reports exceptions but does not process them.
export const OSD_PROCESSING_ROLES = [ROLE_MANAGER, ROLE_ADMIN];
